import type React from 'react';
import Translation from '../../../general/Translation/Translation';
import ButtonStack from '../../../general/Button/ButtonStack';
import Button from '../../../general/Button/Button';
import { useIsMobile } from '../../../general/hooks/useSize';
import { useIsInitialRequestMobile } from '../../../general/WebshopContext/WebshopContext';

export interface DeleteModalProps {
    onAccept: () => void;
    onClose: () => void;
}

const DeleteModal: React.FC<DeleteModalProps> = ({ onAccept, onClose }) => {
    const isMobileOrTablet = useIsMobile(useIsInitialRequestMobile());

    return (
        <div
            className="fancybox-wrap fancybox-desktop fancybox-type-html fancybox-opened"
            style={{
                height: 'auto',
                left: isMobileOrTablet ? '0' : '50%',
                marginLeft: isMobileOrTablet ? '0' : '-195px',
                marginTop: isMobileOrTablet ? '-156px' : '-135px',
                maxWidth: isMobileOrTablet ? '100%' : '390px',
                opacity: 1,
                overflow: 'visible',
                position: 'absolute',
                top: '50%',
                width: '100%',
            }}
        >
            <div
                className="fancybox-skin"
                style={{
                    padding: '15px',
                }}
            >
                <div className="fancybox-outer">
                    <div className="fancybox-inner">
                        <div className="content is-centered">
                            <p><Translation pageString='winkelmand_teksten' stringId='remove_product_dialog' /></p>
                            <ButtonStack isSm isStacked isFluid>
                                <Button
                                    isPrimary
                                    onClick={onAccept}
                                >
                                    <Translation pageString='winkelmand_teksten' stringId='remove_product_dialog_confirm' />
                                </Button>
                                <Button
                                    isGhost
                                    onClick={onClose}
                                >
                                    <Translation pageString='winkelmand_teksten' stringId='remove_product_dialog_cancel' />
                                </Button>
                            </ButtonStack>
                        </div>
                    </div>
                </div>
                <button onClick={onClose} className="fancybox-item fancybox-close" type="button" aria-label="Close modal" />
            </div>
        </div>
    );
};

export default DeleteModal;
